// extracted by css-extract-rspack-plugin
export default {"root":"NameInput-module__root___hl5tC","input":"NameInput-module__input___ln9TG"};